module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAGBAMAAAAmmzNnAAAAAXNSR0IArs4c6QAAACRQTFRFAAAA/6pV/59g/5Vg/5Fn/5Jn/5Jn/5Jl/5Fl/5Jl/5Fm/5Flk8PS3QAAAAt0Uk5TAAMIGCUvUrHH4PHi7zBVAAAAMElEQVQI12MwXxHAwMCAIKt3TwSyEOTq3VuALATZvXsRkIUgI3clAFkIktEJyECQAGx8GguC9TdFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audit1.png
// module id = MDRA
// module chunks = 0